// extracted by mini-css-extract-plugin
export default {"sectorContainer":"Sectors_sectorContainer__VBgJ0","sectorsContainer":"Sectors_sectorsContainer__LeYkr"};